import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/useAuthStore'
import { wrongTenantRedirect } from '@/lib/tenantHost'
import { ExternalRedirect } from './TenantRoutes'

/**
 * Renders child routes only when the user is authenticated; otherwise redirects to login.
 * With tenant subdomains on, the app only runs on the user's own organization's
 * subdomain: the session cookie is shared across subdomains, so someone signed
 * in to Acme who opens globex.kaamco.com is sent back to acme.kaamco.com.
 */
export function PrivateRoute(): React.ReactElement {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const organizationSlug = useAuthStore((s) => s.user?.organizationSlug)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  const redirect = wrongTenantRedirect(organizationSlug)
  if (redirect) {
    return <ExternalRedirect to={redirect} />
  }

  return <Outlet />
}
